import { px } from './stylesUtils';

// Theme selector that takes any argument and returns a string or number

export const cssProp = (selector, value) => {
  if (!value) {
    return undefined;
  }
  return selector(value) || value;
};
export const cssValueProp = (adapter, value, key) => {
  if (!value) {
    return {};
  }
  const themeValue = adapter(value);
  return {
    [key]: themeValue !== null ? themeValue : value
  };
};
export const cssValuesProp = (adapter, values, key) => {
  if (values === undefined) {
    return {};
  }
  const getValue = value => value !== undefined ? px(adapter(value) || value) : undefined;
  if (typeof values === 'number' || typeof values === 'string') {
    return {
      [key]: getValue(values)
    };
  }
  if (Array.isArray(values)) {
    if (values.length === 0) {
      return {};
    }
    return {
      [key]: values.map(getValue).join(' ')
    };
  }
  if (typeof values === 'object') {
    return {
      ["".concat(key, "Top")]: getValue(values.top),
      ["".concat(key, "Right")]: getValue(values.right),
      ["".concat(key, "Bottom")]: getValue(values.bottom),
      ["".concat(key, "Left")]: getValue(values.left)
    };
  }
  return {};
};